import CryptoJS from "crypto-js";
import { API_BASE } from "../config";

const ReferenciaOnline = (referencia, importe)=>{
    let formData = new FormData();
    const datos = referencia.concat(importe)
    formData.append("importe", datos);
    formData.append(
      "cod",
      CryptoJS.SHA256("pcecytej-".concat(datos, "-pcecytej"))
    );
    
    const fun = async () => {
      const res = await fetch(
        `${API_BASE}/wsreferencias.php`,
        { body: formData, method: "POST" }
      );
      const resp = await res.json();
      return resp[0].importe
    };
    
    return fun();
}

export default ReferenciaOnline